import React from 'react';
import { Flex, Spinner, Text } from '@contentful/f36-components';

interface MessageProps {
  text: string;
  spinner?: boolean;
}
export const Message: React.FC<MessageProps> = ({ text, spinner = false }) => {
  return (
    <Flex alignItems="baseline" gap="spacingS">
      <Text>{text}</Text>
      {spinner && <Spinner />}
    </Flex>
  );
};
